import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import CompensationEditContainer from 'buyside/components/container/CompensationSubmission/CompensationEditContainer';

const CompensationEditPageRoot = () => {
  const id = Number(window.location.pathname.split('/')[3]);

  return (
    <ErrorBoundary pageName="compensation edit">
      <CompensationEditContainer id={id} />
    </ErrorBoundary>
  );
};

export default CompensationEditPageRoot;
